'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapValuesWithKey = _mapValues2.default.convert({ cap: false });
var linkHandlersBefore = mapValuesWithKey(function (handler, name) {
  return function (props) {
    return function () {
      handler(props).apply(undefined, arguments); // memoize(handler)(props)?
      if (props[name]) props[name].apply(props, arguments);
    };
  };
});

exports.default = linkHandlersBefore;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/linkHandlersBefore.js
// module id = 1684
// module chunks = 0